import styled from 'styled-components';
import { BorderRadius, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  ${Mixins.Flex.set('center', 'center', 'row')}
  padding: ${Spacing.SINGLE_HALF};
  margin: ${Spacing.SINGLE};
  background: ${Colors.GRAY_LITE_30};
  border-radius: ${BorderRadius.S};
`;

export const Text = styled.i`
  margin: 0;
  font-size: ${Font.Size.S};
  font-family: ${Font.Family.BODY_SANS};
  color: ${Colors.GRAY_DARK_20};
`;
